module.exports = __webpack_public_path__ + "static/media/mars-5.52c1d7ee.jpg";